import React, { Component } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import PropTypes from "prop-types";
import { ErrorText } from "react-spark";
import { withValidation } from "../hocs/WithValidation";
import {
  withValidationOutputPropTypes,
  sharedFormInputPropTypes,
} from "../hocs/prop-types";

class Recaptcha extends Component {
  constructor(props) {
    super(props);
    this.name = "recaptchaResponse";
  }

  componentDidMount() {
    this.props.context.registerFormElement({
      value: this.value,
      name: this.name,
      valid: Boolean(this.value),
      validate: this.props.handleValidation
    });
  }

  componentWillUnmount() {
    this.props.context.deregisterFormElement({
      name: this.props.name,
    }, this);
  }

  handleChange(value) {
    const { handleChange, context } = this.props;
    this.value = value;
    const event = {
      target: {
        value,
        name: this.name
      },
      type: "blur"
    };
    handleChange(event, context);
    this.props.context.updateFormElement({
      value: this.value,
      name: this.name,
      valid: Boolean(this.value)
    });
  }

  render() {
    const { error, errorMessage, sitekey } = this.props;

    return (
      <div className="sprk-u-pvm"> 
        <ReCAPTCHA
          size="normal"
          theme="light"
          type="image"
          onChange={value => this.handleChange(value)}
          onExpired={() => this.handleChange()}
          sitekey={sitekey}
        />
        <ErrorText id="recaptcha" error={error && errorMessage}></ErrorText>
      </div>
    );
  }
}

Recaptcha.propTypes = {
  ...withValidationOutputPropTypes,
  ...sharedFormInputPropTypes,
  sitekey: PropTypes.string.isRequired,
  handleValidation: PropTypes.func.isRequired
};

export default withValidation(Recaptcha);
